export default "__VITE_ASSET__D44lJh1l__"